import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  PresaleSuccessPage,
  presaleCampaignSearchSchema,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleCampaignSearchSchema.shape,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/success")({
  component: PresaleSuccessPage,
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      { title: "Birdwatch - Welcome" },
      { name: "description", content: "Your Founding Membership is reserved" },
    ],
  }),
});
